import { useNavigate } from "react-router";
import PageMeta from "../../components/common/PageMeta";
import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import InviteCollaboratorForm from "../../components/collaborators/InviteCollaboratorForm";

export default function InviteCollaborator() {
    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate("/collaborators");
    };

    return (
        <>
            <PageMeta
                title="Sellyo - Convidar Colaborador"
                description="Convidar novo colaborador para o sistema"
            />
            <PageBreadcrumb
                pageTitle="Convidar Colaborador"
                showBackButton={true}
                onBack={handleGoBack}
            />

            <div className="container mx-auto px-4 md:px-6">
                <InviteCollaboratorForm
                    onSuccess={() => {
                        navigate("/collaborators");
                    }}
                    onError={(error) => {
                        console.error("Erro ao convidar colaborador:", error);
                    }}
                />
            </div>
        </>
    );
}
